import { InjectionToken } from '@angular/core';

/** Browser Maps JavaScript API + Geocoding REST (restrict key by HTTP referrer in GCP). */
export const GOOGLE_MAPS_API_KEY = new InjectionToken<string>(
  'GOOGLE_MAPS_API_KEY',
  { factory: () => '' },
);
